import { siteConfig } from "@/data/siteData";
import { Link } from "@tanstack/react-router";
import { motion } from "framer-motion";

const ease = [0.16, 1, 0.3, 1] as const;

const Section = ({ children, alt = false }: { children: React.ReactNode; alt?: boolean }) => (
  <section className={alt ? "bg-card" : "bg-background"}>
    <div className="max-w-[800px] mx-auto px-3 md:px-6 py-16 md:py-24 lg:py-32">
      {children}
    </div>
  </section>
);

const Impressum = () => (
  <>

    {/* Minimal Hero */}
    <header className="relative bg-card pt-36 md:pt-44 pb-14 md:pb-20 overflow-hidden">
      <div className="max-w-[1400px] mx-auto px-3 md:px-6">
        <motion.p
          initial={false}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.6, ease, delay: 0.2 }}
          className="text-brand-label text-brand-ink mb-4"
        >
          RECHTLICHES
        </motion.p>
        <motion.h1
          initial={false}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease, delay: 0.3 }}
          className="text-brand-heading text-foreground uppercase"
        >
          Impressum
        </motion.h1>
      </div>
    </header>

    <Section>
      <h2 id="legal-1" className="text-brand-subheading mb-4">Firmenangaben</h2>
      <div className="text-brand-body text-muted-foreground space-y-1">
        <p className="font-semibold text-foreground">VMAX Services AG</p>
        <p>Schwarzhaarhalde 4</p>
        <p>4665 Oftringen</p>
        <p className="pt-2">Handelsregister: CH-400.3.455.186-2</p>
        <p>UID: CHE-320.464.976</p>
      </div>
    </Section>

    <Section alt>
      <h2 id="legal-2" className="text-brand-subheading mb-4">Marke</h2>
      <p className="text-brand-body text-muted-foreground">
        <span className="text-foreground font-semibold">{siteConfig.firmaName}</span> ist eine eingetragene Marke der VMAX Services AG.
      </p>
    </Section>

    <Section>
      <h2 id="legal-3" className="text-brand-subheading mb-4">Verantwortlicher</h2>
      <div className="text-brand-body text-muted-foreground space-y-1">
        <p className="font-semibold text-foreground">Anton Nue</p>
        <p>Geschäftsführer, VMAX Services AG</p>
      </div>
    </Section>

    <Section alt>
      <h2 id="legal-4" className="text-brand-subheading mb-4">Kontakt</h2>
      <div className="text-brand-body text-muted-foreground space-y-1">
        <p>Telefon: <a href={`tel:${siteConfig.firmaTelefon.replace(/\s/g, "")}`} className="text-foreground hover:text-brand-ink transition-colors">{siteConfig.firmaTelefon}</a></p>
        <p>E-Mail: <a href={`mailto:${siteConfig.firmaEmail}`} className="text-foreground hover:text-brand-ink transition-colors">{siteConfig.firmaEmail}</a></p>
        <p>Web: <a href={siteConfig.firmaUrl} className="text-foreground hover:text-brand-ink transition-colors">{siteConfig.firmaUrl}</a></p>
      </div>
    </Section>

    <Section>
      <h2 id="legal-5" className="text-brand-subheading mb-4">Haftungsausschluss</h2>
      <p className="text-brand-body text-muted-foreground">
        Die Inhalte dieser Website werden mit grösstmöglicher Sorgfalt erstellt. Die VMAX Services AG übernimmt jedoch keine Gewähr für die Richtigkeit, Vollständigkeit und Aktualität der bereitgestellten Inhalte. Die Nutzung der Inhalte erfolgt auf eigene Gefahr.
      </p>
    </Section>

    <Section alt>
      <h2 id="legal-6" className="text-brand-subheading mb-4">Haftung für Links</h2>
      <p className="text-brand-body text-muted-foreground">
        Diese Website enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter verantwortlich. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Links umgehend entfernen.
      </p>
    </Section>

    <Section>
      <h2 id="legal-7" className="text-brand-subheading mb-4">Urheberrecht</h2>
      <p className="text-brand-body text-muted-foreground">
        Alle Inhalte und Werke auf dieser Website unterliegen dem Schweizer Urheberrecht. Jede Verwertung ausserhalb der Grenzen des Urheberrechts bedarf der schriftlichen Zustimmung der VMAX Services AG.
      </p>
    </Section>

    <Section alt>
      <h2 id="legal-8" className="text-brand-subheading mb-4">Weitere rechtliche Informationen</h2>
      <div className="flex flex-col gap-2 text-brand-body">
        <Link to="/datenschutz/" className="text-foreground hover:text-brand-ink transition-colors">Datenschutzerklärung →</Link>
        <Link to="/agb/" className="text-foreground hover:text-brand-ink transition-colors">Allgemeine Geschäftsbedingungen →</Link>
      </div>
    </Section>
  </>
);

export default Impressum;
